import React, { useContext, useEffect } from "react";
import { History } from "history";
import { useSelector } from "react-redux";
import { AuthState } from "../../context/auth/auth/reducer";
import { ROUTES } from "../../routing/routes";
import Footer from "../../components/shared/footer/Footer";
import { GlobalLoadingContext, IGlobalLoadingContext } from "../../providers/GlobalLoading";
import Navbar from "../../components/shared/navbar/Navbar";
import queryString from "query-string";
import { COOKIES } from "../../data/enums";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  history: History;
  children: any;
  alwaysVisible: boolean;
}

const PublicLayout = ({ history, children, alwaysVisible, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to loading manager provider that you may use to show and hide global loading
  const { hideGlobalLoading } = useContext<IGlobalLoadingContext>(GlobalLoadingContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[PublicLayout] init");
  };

  const canIStayHere = (user: any): boolean => {
    return !user || alwaysVisible;
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[PublicLayout] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle authorization
   */
  useEffect(() => {
    hideGlobalLoading();

    console.log("REDIRECT", history);
    if (!canIStayHere(user)) {
      // Handle redirect url

      let params = queryString.parse(history.location.search);

      console.log(params);

      if (!!params && !!params.redirect_url && typeof params.redirect_url === "string") {
        history.push(params.redirect_url);
      } else {
        history.push({ pathname: ROUTES.HOME });
      }
    }
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className={`public-layout${user || alwaysVisible ? " with-navbar" : ""}`}>
      {alwaysVisible && <Navbar/>}
      {children}
      <Footer/>
    </div>
  );
};
export default PublicLayout;
